import { localized } from "@lit/localize";
import { BaseCodeTask, type ExecutionResult } from "@whilecat/core/tasks/common/base-code-task.ts";
import type { CodeEditorParams } from "@whilecat/core/tasks/java/params/code-editor-params.js";
import { CodeEditorParamsValidator } from "@whilecat/core/tasks/java/params/validators/code-editor-params-validator.ts";
import { CodeEditorVerifier } from "@whilecat/core/tasks/java/verificators/code-editor-verifier.ts";
import { CodeType, compileCode } from "@whilecat/services/java-compiler-service.ts";
import { html } from "lit";
import { customElement } from "lit/decorators.js";

@localized()
@customElement("code-editor-task")
export class CodeEditorTask extends BaseCodeTask<CodeEditorParams> {
    private readonly paramsValidator = new CodeEditorParamsValidator();
    codeType = CodeType.CLASS;

    static html(taskId: string, data: CodeEditorParams, completed: boolean, repetitionMode: boolean) {
        return html`
          <code-editor-task
                  .taskId=${taskId}
                  .data=${data}
                  .completed="${completed}"
                  .repetitionMode="${repetitionMode}">
          </code-editor-task>`;
    }

    async executor(code: string, type: CodeType): Promise<ExecutionResult<string>> {
        const { data } = await compileCode(code, type);
        return data!;
    }

    override get codeVerifier() {
        return new CodeEditorVerifier(this.data);
    }

    override validateData() {
        this.paramsValidator.validate(this.data);
    }
}
